import { createContext, useContext, useState, useEffect } from "react";

type AcademicYear = {
  id: string;
  label: string;
  startDate: string;
  endDate: string;
  statut: boolean;
  Student?: {
    id: string;
    firstname: string;
    lastname: string;
    matricule: string;
    blocked_Note: boolean;
    Class?: {
      id: string;
      label: string;
      abbreviation: string;
    };
    Level?: {
      id: string;
      label: string;
      abbreviation: string;
    };
  };
};

type ContextType = {
  selectedYear: AcademicYear | null;
  setSelectedYear: (year: AcademicYear) => void;
};

const AcademicYearContext = createContext<ContextType | undefined>(undefined);

export const AcademicYearProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [selectedYear, setSelectedYear] = useState<AcademicYear | null>(null);

  // Load from localStorage when app starts
  useEffect(() => {
    const stored = localStorage.getItem("selectedAcademicYear");
    if (stored) {
      setSelectedYear(JSON.parse(stored));
    }
  }, []);

  // Save to localStorage when value changes
  useEffect(() => {
    if (selectedYear) {
      localStorage.setItem(
        "selectedAcademicYear",
        JSON.stringify(selectedYear),
      );
    }
  }, [selectedYear]);

  return (
    <AcademicYearContext.Provider value={{ selectedYear, setSelectedYear }}>
      {children}
    </AcademicYearContext.Provider>
  );
};

export const useAcademicYear = () => {
  const context = useContext(AcademicYearContext);
  if (!context) {
    throw new Error("useAcademicYear must be used within AcademicYearProvider");
  }
  return context;
};
